import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

export interface OthersSizeProps {
  children: React.ReactNode;
}

export function OthersSize({ children }: OthersSizeProps) {
  return <Wrapper>{children}</Wrapper>;
}

const Wrapper = styled.div``;

const Title = styled.div`
  padding: 19px 16px 13px;
  border-bottom: 1px solid ${vars.v3Color.gray100};
`;

const Subtitle = styled.div`
  padding: 24px 16px 24px;
  color: ${vars.v3Color.gray400};
  text-align: center;
  white-space: pre-line;
  line-height: 140%;
`;

const InfoText = styled.span`
  padding-right: 3px;
  &::after {
    content: ',';
  }
  &:last-of-type {
    padding-right: 0;
  }
  &:last-of-type::after {
    display: none;
  }
`;

const List = styled.div`
  margin: 0 16px 20px;
  border-radius: 8px;
  background-color: ${vars.v3Color.gray100};
`;

const ListHeader = styled.div`
  padding: 14px 0 12px;
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  color: ${vars.v3Color.gray900};
  border-bottom: 1px solid ${vars.v3Color.gray150};
`;

const TooltipTrigger = styled.button`
  display: flex;
  align-items: center;
  margin-left: 4px;
`;

OthersSize.Title = Title;
OthersSize.Subtitle = Subtitle;
OthersSize.InfoText = InfoText;
OthersSize.List = List;
OthersSize.ListHeader = ListHeader;
OthersSize.TooltipTrigger = TooltipTrigger;
